import request from "../Utils/Request";

export function postData(url: string, data: any, options?: any) {
  return request.post(url, data, options ? options : {});
}
